<div class="refreshBtn" (click)="refresh()">
  <i class="material-icons md-48">refresh</i>
</div>
